const DEFAULT_BORDER_COLOR = '#222222';

export type PostSectionStyleAttrs = {
  backgroundColor?: string | null;
  color?: string | null;
  marginTop?: number | null;
  marginRight?: number | null;
  marginBottom?: number | null;
  marginLeft?: number | null;
  paddingTop?: number | null;
  paddingRight?: number | null;
  paddingBottom?: number | null;
  paddingLeft?: number | null;
  borderColor?: string | null;
  borderStyle?: string | null;
  borderWidthTop?: number | null;
  borderWidthRight?: number | null;
  borderWidthBottom?: number | null;
  borderWidthLeft?: number | null;
  useIndividualBorderWidth?: boolean;
  borderTopLeftRadius?: number | null;
  borderTopRightRadius?: number | null;
  borderBottomRightRadius?: number | null;
  borderBottomLeftRadius?: number | null;
  useIndividualBorderRadius?: boolean;
};

export const buildPostSectionVars = (attrs: PostSectionStyleAttrs): Record<string, string> => {
  const vars: Record<string, string> = {
    '--post-section-margin-top': `${attrs.marginTop ?? 0}px`,
    '--post-section-margin-right': `${attrs.marginRight ?? 0}px`,
    '--post-section-margin-bottom': `${attrs.marginBottom ?? 0}px`,
    '--post-section-margin-left': `${attrs.marginLeft ?? 0}px`,
    '--post-section-padding-top': `${attrs.paddingTop ?? 0}px`,
    '--post-section-padding-right': `${attrs.paddingRight ?? 0}px`,
    '--post-section-padding-bottom': `${attrs.paddingBottom ?? 0}px`,
    '--post-section-padding-left': `${attrs.paddingLeft ?? 0}px`,
    '--post-section-border-color': attrs.borderColor || DEFAULT_BORDER_COLOR,
    '--post-section-border-style': attrs.borderStyle || 'solid',
  };

  if (attrs.backgroundColor) {
    vars['--post-section-background-color'] = attrs.backgroundColor;
  }

  if (attrs.color) {
    vars['--post-section-text-color'] = attrs.color;
  }

  // Border widths: when not using individual widths, every side mirrors the top.
  const uniformBorderWidth = attrs.borderWidthTop ?? 0;
  vars['--post-section-border-top-width'] = `${uniformBorderWidth}px`;
  vars['--post-section-border-right-width'] =
    `${attrs.useIndividualBorderWidth ? (attrs.borderWidthRight ?? 0) : uniformBorderWidth}px`;
  vars['--post-section-border-bottom-width'] =
    `${attrs.useIndividualBorderWidth ? (attrs.borderWidthBottom ?? 0) : uniformBorderWidth}px`;
  vars['--post-section-border-left-width'] =
    `${attrs.useIndividualBorderWidth ? (attrs.borderWidthLeft ?? 0) : uniformBorderWidth}px`;

  // Border radii: when not using individual radii, every corner mirrors the top-left.
  const uniformBorderRadius = attrs.borderTopLeftRadius ?? 0;
  vars['--post-section-border-top-left-radius'] = `${uniformBorderRadius}px`;
  vars['--post-section-border-top-right-radius'] =
    `${attrs.useIndividualBorderRadius ? (attrs.borderTopRightRadius ?? 0) : uniformBorderRadius}px`;
  vars['--post-section-border-bottom-right-radius'] =
    `${attrs.useIndividualBorderRadius ? (attrs.borderBottomRightRadius ?? 0) : uniformBorderRadius}px`;
  vars['--post-section-border-bottom-left-radius'] =
    `${attrs.useIndividualBorderRadius ? (attrs.borderBottomLeftRadius ?? 0) : uniformBorderRadius}px`;

  return vars;
};
